// extracted by mini-css-extract-plugin
module.exports = {"viewMoreText":"collapsibleContent_viewMoreText__poIhS"};